import {
    Box,
    Button,
    Chip, CircularProgress,
    IconButton,
    Table,
    TableBody,
    TableCell,
    TableHead,
    TablePagination,
    TableRow,
    Tooltip,
    Typography,
} from "@material-ui/core";

import AddIcon from "@material-ui/icons/Add";
import CheckIcon from "@material-ui/icons/Check";
import { Visibility } from "@material-ui/icons";
import { clampText, stripHtml } from "./utils";
import {Loading} from "react-admin";

function QuestionRow({ question, isSelected, onAdd, onOpenDetails }) {
    const snippet = clampText(stripHtml(question.question), 140);
    const originLabel = question.ownerId == null ? "Pré-cadastrada" : "Minha";

    return (
        <TableRow key={question.id} hover>
            <TableCell>
                <Typography variant="subtitle2">{question.name}</Typography>
                <Typography variant="caption" color="textSecondary">
                    {originLabel}
                </Typography>
                <Box mt={0.5}>
                    {question.tags.slice(0, 3).map((tag) => (
                        <Chip
                            key={tag}
                            size="small"
                            label={tag}
                            style={{ marginRight: 4, marginBottom: 4 }}
                        />
                    ))}
                </Box>
            </TableCell>

            <TableCell>{question.theme?.name || "-"}</TableCell>

            <TableCell>
                <Typography variant="body2" color="textSecondary">
                    {snippet}
                </Typography>
            </TableCell>

            <TableCell align="right">
                <Tooltip title="Ver detalhes">
                    <IconButton onClick={() => onOpenDetails(question)} size="small">
                        <Visibility fontSize="small" />
                    </IconButton>
                </Tooltip>

                {isSelected ? (
                    <Tooltip title="Já adicionada ao banco">
                        <span>
                            <Button
                                size="small"
                                variant="contained"
                                disabled
                                startIcon={<CheckIcon />}
                                style={{ marginLeft: 8 }}
                            >
                                Adicionada
                            </Button>
                        </span>
                    </Tooltip>
                ) : (
                    <Tooltip title="Adicionar ao banco">
                        <span>
                            <Button
                                size="small"
                                variant="contained"
                                color="primary"
                                onClick={() => onAdd(question)}
                                startIcon={<AddIcon />}
                                style={{ marginLeft: 8 }}
                            >
                                Adicionar
                            </Button>
                        </span>
                    </Tooltip>
                )}
            </TableCell>
        </TableRow>
    );
}

export function QuestionTable({
    questions,
    selectedIds,
    onAdd,
    onOpenDetails,
    total,
    page,
    rowsPerPage,
    onPageChange,
    onRowsPerPageChange,
    loading
}) {
    if (loading) {
        return (
            <div style={{height: '600px', display: 'flex', alignItems: 'center', gap: 29, justifyContent: 'center', flexDirection: 'column'}}>
                <CircularProgress />
                <Typography variant="h5" color="textSecondary">Carregando dados</Typography>
            </div>
        )
    }
    return (
        <>
            <Table size="small">
                <TableHead>
                    <TableRow>
                        <TableCell style={{ width: 220 }}>Questão</TableCell>
                        <TableCell style={{ width: 180 }}>Área do direito</TableCell>
                        <TableCell width="40%">Prévia</TableCell>
                        <TableCell style={{ width: 220 }} align="right">
                            Ações
                        </TableCell>
                    </TableRow>
                </TableHead>

                <TableBody>
                    {questions.map((q) => (
                        <QuestionRow
                            key={q.id}
                            question={q}
                            isSelected={selectedIds.has(q.id)}
                            onAdd={onAdd}
                            onOpenDetails={onOpenDetails}
                        />
                    ))}
                </TableBody>
            </Table>

            <TablePagination
                component="div"
                count={total}
                page={page - 1}
                onPageChange={(_, newPage) => {
                    onPageChange(newPage + 1)
                }}
                rowsPerPage={rowsPerPage}
                onRowsPerPageChange={(e) => onRowsPerPageChange(parseInt(e.target.value, 10))}
                rowsPerPageOptions={[10, 20, 50]}
                labelRowsPerPage="Linhas por página"
                labelDisplayedRows={({ from, to, count }) => `${from}-${to} de ${count}`}
            />
        </>
    );
}
